import type {
    Organization,
    OrganizationEditionInput,
    OrganizationId,
} from '@wwf/sdk';
import { RAFile } from './types';

export type OrganizationInput = OrganizationEditionInput & {
    id?: OrganizationId;
    logoInput?: RAFile;
    chatbotAssistantAvatarInput?: RAFile;
    mascotHugImageInput?: RAFile;
};

/** Organization record returned from data providers (always has an id). */
export type OrganizationRecord = OrganizationInput & {
    id: OrganizationId;
};

export function organizationToInput(org: Organization): OrganizationInput {
    const { logo, mascotHugImage, chatbotAssistantAvatar, ...edition } = org;

    return {
        ...edition,
        logoId: logo?.id ?? null,
        mascotHugImageId: mascotHugImage?.id ?? null,
        chatbotAssistantAvatarId: chatbotAssistantAvatar?.id ?? null,
    };
}
